import { render, staticRenderFns } from "./FeedCard.vue?vue&type=template&id=c540fb24&scoped=true&"
import script from "./FeedCard.vue?vue&type=script&lang=js&"
export * from "./FeedCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedCard.vue?vue&type=style&index=0&id=c540fb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c540fb24",
  null
  
)

export default component.exports